import { motion } from 'framer-motion';
import Reveal from './Reveal';
import { PRODUCTS } from '../lib/site';

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

const GRID_VIEWPORT = { once: true, margin: '-80px' };
const CARD_STYLE = { minHeight: '320px' };

const ProductCard = ({ product, index }) => (
  <motion.div
    variants={cardVariants}
    className="group relative overflow-hidden bg-[#0A1628] cursor-default"
    style={CARD_STYLE}
    data-testid={`product-card-${index}`}
  >
    <div className="absolute inset-0">
      <img
        src={product.image}
        alt={product.name}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050B14]/95 via-[#050B14]/60 to-[#050B14]/20" />
      <div className="absolute inset-0 bg-[#050B14]/30 group-hover:bg-[#050B14]/10 transition-colors duration-500" />
    </div>

    <div className="relative h-full flex flex-col justify-end p-8">
      <span className="font-body text-[10px] uppercase tracking-[0.25em] text-[#00E5FF] mb-2 font-semibold">
        {product.tagline}
      </span>
      <h3 className="font-display font-semibold text-white text-2xl md:text-3xl mb-0 leading-tight">
        {product.name}
      </h3>
      <div className="overflow-hidden max-h-40 md:max-h-0 md:group-hover:max-h-40 transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]">
        <p className="font-body text-sm text-[#94A3B8] leading-relaxed font-light pt-4">
          {product.desc}
        </p>
        <div className="mt-4 h-px w-12 bg-[#00E5FF]" />
      </div>
    </div>

    <div className="absolute top-0 left-0 w-px h-0 bg-[#00E5FF] group-hover:h-10 transition-all duration-500" />
    <div className="absolute top-0 left-0 h-px w-0 bg-[#00E5FF] group-hover:w-10 transition-all duration-500" />
  </motion.div>
);

export default function WhatWeMove() {
  return (
    <section id="products" className="bg-[#0A1628] py-28 lg:py-36" data-testid="products-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal className="mb-16 max-w-2xl">
          <span className="font-body text-[11px] font-semibold uppercase tracking-[0.25em] text-[#00E5FF]">
            What We Move
          </span>
          <span className="line-electric mt-3 mb-6 block" />
          <h2
            className="font-display font-semibold text-white leading-[1.1]"
            style={{ fontSize: 'clamp(2rem, 3.5vw, 3rem)' }}
          >
            Six commodity segments. One integrated platform.
          </h2>
          <p className="mt-5 font-body text-base text-[#94A3B8] leading-relaxed font-light">
            From legacy hydrocarbons to clean energy carriers, Voyager moves the full spectrum of energy molecules across global markets.
          </p>
        </Reveal>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={GRID_VIEWPORT}
          className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/5"
          data-testid="products-grid"
        >
          {PRODUCTS.map((product, i) => (
            <ProductCard key={product.name} product={product} index={i} />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
